module.exports = __webpack_public_path__ + "static/images/fields/date_field.svg";